import { identity, noop } from 'lodash/fp';

export {
    MAX_TERM_NAME_LENGTH,
    MAX_CUSTOM_PROPERTY_OPTION_LENGTH,
    MAX_LONG_TEXT_PROPERTY_LENGTH,
    MAX_DESCRIPTION_LENGTH,
    Theme,
    LayoutDirection,
    LayoutJustification
} from './ui';
export { NAME_REGEXP, LONG_TEXT_REGEXP } from './regex';

export { KeySequence } from './keybindings';

export {
    SHORT_TEXT,
    LONG_TEXT,
    SINGLE_SELECT,
    SHORT_TEXT_DEFINITION,
    LONG_TEXT_DEFINITION,
    SINGLE_SELECT_DEFINITION,
    BOOLEAN_DEFINITION,
    SELECT_OPTION_APPEARANCE,
    ADD_SELECT_OPTION,
    RENAME_SELECT_OPTION,
    REMOVE_SELECT_OPTION,
    UPDATE_SELECTION_DEFINITION,
    CustomPropertyDefinitionTypes,
    CustomPropertyDefinitionToTypes,
    CustomPropertyTargets,
    CustomPropertyI18nKeys
} from './customProperties';
export {
    DATMEER_CONNECTION,
    LOCAL_FILE_CONNECTION,
    SNOWFLAKE_CONNECTION,
    UPLOAD_CONNECTION
} from './connectionTypes';
export {
    GlossaryKeyByEntityType,
    EXTRACT_JSON,
    GROUP_NODE,
    DeployableViewTypes,
    JOBS,
    FILTER,
    MULTI_JOIN,
    ERROR_NODE
} from './entityTypes';
export { SOURCE_NOT_AVAILABLE } from './fallbacks';
export { FlowMode } from './flowDiagram';
export {
    URL_HELP_MARKDOWN,
    URL_USER_MANUAL,
    DocuUrlByOperation,
    URL_DOC_SNOWFLAKE_ADMIN_ACCOUNT_IDENTIFIER,
    URL_DOC_SNOWFLAKE_COPY_INTO_LOCATION,
    URL_DOC_SNOWFLAKE_COPY_INTO_TABLE_COPY_OPTIONS,
    URL_DOC_SNOWFLAKE_COPY_INTO_TABLE_FORMAT_TYPE_OPTIONS,
    URL_DOCU_SERVICE_ACCOUNT,
    URL_DOCU_CUSTOM_PROPERTIES,
    URL_DOCU_DEPLOYING_PERMISSIONS,
    URL_DOCU_SAMPLE_PROJECT,
    URL_DOCU_SETUP_SLACK,
    URL_PRODUCT_PRICING,
    SANDBOX_ACCOUNT_NAME
} from './externalUrls';
export {
    OperationType,
    Operations,
    OperationGlossaryKey,
    AggregationType,
    AggregationGlossaryKey
} from './operations';
export { UnionMode, UnionIcon } from './union';
export {
    MEASURES,
    SECONDARY_DIMENSIONS,
    PrimaryDimensions,
    DashboardTabs,
    ChartType,
    DateBin,
    TrendDirection,
    TrendIcon,
    CARDINALITY_THRESHOLD,
    ROI_CHART_KEY,
    ASSET_ROI_MEASURES,
    AssetRoiDimensions,
    ACCESS_TYPE,
    ROIReportTabs
} from './usageReporting';

export enum FetchStatus {
    IDLE,
    FETCHING,
    SUCCEEDED,
    FAILED
}

export enum AssetStatus {
    NONE,
    ADDED,
    USED
}

export enum AssetFilter {
    ALL,
    ADDED,
    USED,
    SCHEDULED,
    CREATED_BY_DATAMEER
}

export enum ErrorLevel {
    OK,
    INFO,
    WARNING,
    ERROR
}

export enum RequestStatus {
    IDLE,
    PENDING,
    RESOLVED,
    REJECTED
}

export enum QueryState {
    IDLE = 0,
    RUNNING = 1,
    CANCELED = 3,
    SUCCESS = 4,
    FAILED = 5,
    INVALID = 6,
    STALE = 7
}

export enum SortDirection {
    ASC = 1,
    DESC = -1
}

export const MAX_PIVOT_COLUMNS_COUNT = 24;
export const MAX_PIVOT_CARDINALITY = 100;

export enum SearchTypes {
    PROJECT = 'PROJECT',
    DATASET = 'DATA_SOURCE'
}

export enum ShareSourceType {
    EXPLORATION = 'EXPLORATION',
    TRANSFORMATION = 'TRANSFORMATION'
}

export enum GoogleConfigurationStatus {
    UNKNOWN = 'UNKNOWN',
    NOT_CONFIGURED = 'NOT CONFIGURED',
    CONFIGURED = 'CONFIGURED'
}

export enum NodeMaterializationState {
    RUNNING = 'Running',
    CANCELED = 'Canceled',
    SUCCESS = 'Success',
    INVALID = 'Invalid'
}

export const WEEKDAYS = [
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY'
];

export const COLOR_SPACE = '#2f394e';
export const COLOR_WHITE = '#ffffff';

export const QUERY_HISTORY_FQN = {
    database: 'SNOWFLAKE',
    schema: 'ACCOUNT_USAGE',
    table: 'QUERY_HISTORY'
};
export const QUERY_HISTORY_FQN_STRING = 'SNOWFLAKE.ACCOUNT_USAGE.QUERY_HISTORY';

export const EVENTS_TABLE_FQN = {
    database: 'DATAQUALITY',
    schema: 'PUBLIC',
    table: 'EVENT'
};
export const EVENTS_TABLE_FQN_STRING = 'DATAQUALITY.PUBLIC.EVENT';
export { JOIN_TYPES, JoinType } from './join.js';

export const Defaults = {
    ARRAY: [],
    OBJECT: {},
    NOOP: noop,
    IDENTITY: identity
};

export const INSPECTOR_MIN_WIDTH_PX = 320;

export const ERROR_CATEGORY = {
    schema: 'SCHEMA',
    dataQuality: 'DATA_QUALITY',
    compilation: 'COMPILATION'
};
